import { queryOptions } from '@tanstack/react-query'
import { apiClient } from '.'
import { Meal, MealOfDayDivision, NewMealOfDayDivision, RecommenderSettings } from './types'

// Energy estimation
export async function getEnergyEstimationEquation() {
  return apiClient.get('/energy-estimation-equation').then((res) => res.data)
}

export async function saveEnergyEstimationEquation(energyEstimationEquation) {
  return apiClient
    .post('/energy-estimation-equation', energyEstimationEquation, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((res) => res.data)
}

export async function resetEnergyEstimationEquation(energyEstimationEquation) {
  return apiClient
    .delete('/energy-estimation-equation', energyEstimationEquation)
    .then((res) => res.data)
}

// Meal divisions
export async function fetchMealParts() {
  return apiClient.get('/mealOfDayDivision/mealParts').then((res) => res.data)
}

export const mealPartsQuery = queryOptions({
  queryKey: ['mealParts'],
  queryFn: fetchMealParts,
})


export async function saveMealOfDayDivision(mealOfDayDivision: NewMealOfDayDivision[]) {
  return apiClient.post('/mealOfDayDivision', mealOfDayDivision).then((res) => res.data)
}

// Dietary restrictions
export async function fetchEnabledDietaryRestrictions() {
  return apiClient.get('/enabled-dietary-restrictions').then((res) => res.data)
}

export async function updateEnabledDietaryRestrictions(dietaryRestrictions) {
  return apiClient
    .post('/enabled-dietary-restrictions', dietaryRestrictions)
    .then((res) => res.data)
}

// Energy distribution
export async function fetchEnergyDistribution() {
  return apiClient.get('/energy-distribution').then((res) => res.data)
}

export async function getValidNumberOfMeals() {
  return apiClient.get('/energy-distribution/validNumbersOfDailyMeals').then((res) => res.data)
}

export async function saveEnergyDistribution(energyDistribution) {
  return apiClient.post('/energy-distribution', energyDistribution).then((res) => res.data)
}

export async function getEnergyDistributionConfiguration() {
  return apiClient.get('/energy-distribution/config').then((res) => res.data)
}

export async function saveEnergyDistributionConfiguration(energyDistribution) {
  return apiClient.post('/energy-distribution/config', energyDistribution).then((res) => res.data)
}

export async function resetEnergyDistributionConfiguration() {
  return apiClient.delete('/energy-distribution/config').then((res) => res.data)
}

export async function getRecommenderSettings(): Promise<RecommenderSettings> {
  return apiClient.get('/recommender-settings').then((res) => res.data)
}

export const recommenderSettingsQuery = queryOptions({
  queryKey: ['recommenderSettings'],
  queryFn: getRecommenderSettings,
})

export async function saveRecommenderSettings(recommenderSettings: RecommenderSettings) {
  return apiClient.post('/recommender-settings', recommenderSettings).then((res) => res.data)
}

export async function resetRecommenderSettings() {
  return apiClient.delete('/recommender-settings').then((res) => res.data)
}